var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRrpTooltipMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    stroke: "#3F3F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90105 7.94643H6.04164C6.0394 7.80013 6.03827 7.71102 6.03827 7.6791C6.03827 7.34927 6.08433 7.07795 6.17645 6.86516C6.26857 6.65236 6.45281 6.41296 6.72917 6.14697C7.00552 5.88097 7.17066 5.70675 7.22459 5.62429C7.30772 5.49395 7.34928 5.35031 7.34928 5.19337C7.34928 4.97526 7.27514 4.78906 7.12685 4.63478C6.98081 4.47785 6.78309 4.39938 6.53369 4.39938C6.29329 4.39938 6.0922 4.48051 5.93043 4.64276C5.76866 4.80502 5.65744 5.0524 5.59678 5.38489L4.72726 5.25721C4.75198 4.78108 4.92274 4.37677 5.23954 4.04427C5.55858 3.71178 5.97649 3.54553 6.49325 3.54553C7.03698 3.54553 7.46949 3.71444 7.79078 4.05225C8.11207 4.38741 8.27272 4.77842 8.27272 5.22529C8.27272 5.47267 8.21318 5.70675 8.0941 5.92752C7.97726 6.1483 7.72562 6.44887 7.33917 6.82925C7.13921 7.02608 7.01451 7.18435 6.96508 7.30405C6.9179 7.42375 6.89655 7.63787 6.90105 7.94643ZM6.04164 9.45462V8.33345H6.98867V9.45462H6.04164Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrpTooltipMark);
export default __webpack_public_path__ + "static/media/rrp_tooltip_mark.225ea942.svg";
export { ForwardRef as ReactComponent };